// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_p0-0";